import { OrderEvent } from '@oolio-group/domain';
import { BehaviorSubject } from 'rxjs';

export const cdsOrderEventsSubject = new BehaviorSubject<OrderEvent[]>([]);
